import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { formatShortDate, formatCurrency } from '../utils/formatters';
import { COLORS, tooltipStyle } from '../theme';

// Custo por conversa por dia (linha âmbar, eixo próprio).
// Dia com 0 conversas -> custo null: a linha QUEBRA (connectNulls=false), em vez de
// despencar pro chão e parecer "custo zero" (o oposto do que aconteceu).
const CostPerConversationChart = ({ data, currency = 'BRL' }) => {
  const chartData = data.map(item => ({
    date: formatShortDate(item.date),
    cost: item.costPerConversation === null || item.costPerConversation === undefined
      ? null
      : parseFloat(item.costPerConversation)
  }));

  return (
    <div className="chart-card">
      <h3 className="chart-title">Custo por conversa por dia</h3>
      <p className="chart-subtitle">Dias sem conversa aparecem como interrupção na linha</p>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={COLORS.border} vertical={false} />
          <XAxis dataKey="date" stroke={COLORS.muted} tick={{ fill: COLORS.muted, fontSize: 12 }} />
          <YAxis
            stroke={COLORS.muted}
            tick={{ fill: COLORS.muted, fontSize: 12 }}
            tickFormatter={(v) => formatCurrency(v, currency)}
            width={80}
          />
          <Tooltip
            {...tooltipStyle}
            cursor={{ stroke: COLORS.custo, strokeWidth: 1, strokeOpacity: 0.4 }}
            formatter={(value) => [formatCurrency(value, currency), 'Custo por conversa']}
          />
          <Line
            type="monotone"
            dataKey="cost"
            name="Custo por conversa"
            stroke={COLORS.custo}
            strokeWidth={2.5}
            dot={{ r: 2.5, fill: COLORS.custo }}
            activeDot={{ r: 5 }}
            connectNulls={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CostPerConversationChart;
